/**
 * Maps widget / integrator partnerId (wpid) to booking website domain.
 * Keep in sync with train-results `src/config/partnerIdMappings.ts`.
 */
const partnerIdToWebsite: Record<string, string> = {
    mci: "www.mountaincollection.com",
    mmv: "www.travelski.com",
};

export function getWebsiteForPartnerId(partnerId: string | undefined | null): string | undefined {
    if (!partnerId?.trim()) return undefined;
    return partnerIdToWebsite[partnerId.trim().toLowerCase()];
}

export function resolveBookingWebsite(opts: {
    partnerId?: string | null;
    website?: string | null;
    hostname?: string | null;
    defaultWebsite?: string;
}): string {
    const explicit = opts.website?.trim();
    if (explicit) return explicit;

    const fromPartner = getWebsiteForPartnerId(opts.partnerId);
    if (fromPartner) return fromPartner;

    const hostname = opts.hostname?.trim();
    if (hostname) return hostname;

    return opts.defaultWebsite ?? "www.travelski.com";
}
